/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PaymentQueryVariables = {
    animalIds: Array<string>;
};
export type PaymentQueryResponse = {
    readonly licensingPaymentForm: {
        readonly rows: ReadonlyArray<{
            readonly animalId: string;
            readonly blocked: boolean;
            readonly rabiesIsValid: boolean;
            readonly " $fragmentRefs": FragmentRefs<"PaymentRow_paymentRow">;
        }>;
        readonly total: number;
        readonly " $fragmentRefs": FragmentRefs<"Donation_paymentForm" | "PayPalForm_paymentForm">;
    } | null;
    readonly configuration: {
        readonly licensingPaymentMethods: ReadonlyArray<string>;
        readonly stripePublishableKey: string;
        readonly makeADonationEnabled: boolean;
        readonly licensingPayPalClientId: string | null;
        readonly currency: string;
        readonly organisationContact: string;
        readonly " $fragmentRefs": FragmentRefs<"PaymentRow_configuration" | "Donation_configuration" | "CardConnectForm_configuration" | "ConvergeProvider_configuration" | "PaymentForm_configuration" | "PayPalForm_configuration" | "GlobalPaymentsButton_configuration" | "GlobalPaymentsForm_configuration" | "PayPalPayflowProvider_configuration" | "MonerisProvider_configuration">;
    } | null;
    readonly licensingContract: {
        readonly text: string | null;
        readonly contractId: number;
    } | null;
};
export type PaymentQuery = {
    readonly response: PaymentQueryResponse;
    readonly variables: PaymentQueryVariables;
};



/*
query PaymentQuery(
  $animalIds: [ID!]!
) {
  licensingPaymentForm(animalIds: $animalIds) {
    rows {
      animalId
      blocked
      rabiesIsValid
      ...PaymentRow_paymentRow
    }
    total
    ...Donation_paymentForm
    ...PayPalForm_paymentForm
  }
  configuration {
    licensingPaymentMethods
    stripePublishableKey
    makeADonationEnabled
    licensingPayPalClientId
    currency
    organisationContact
    ...PaymentRow_configuration
    ...Donation_configuration
    ...CardConnectForm_configuration
    ...ConvergeProvider_configuration
    ...PaymentForm_configuration
    ...PayPalForm_configuration
    ...GlobalPaymentsButton_configuration
    ...GlobalPaymentsForm_configuration
    ...PayPalPayflowProvider_configuration
    ...MonerisProvider_configuration
  }
  licensingContract {
    text
    contractId
  }
}

fragment CardConnectForm_configuration on Configuration {
  cardConnectSourceUri
}

fragment ConvergeProvider_configuration on Configuration {
  elavonConvergeLibraryUri
  currency
  organisationContact
}

fragment Donation_configuration on Configuration {
  currency
  donationAmountSuggestions
  donationRoundUp
}

fragment Donation_paymentForm on LicensingPaymentForm {
  total
}

fragment GlobalPaymentsButton_configuration on Configuration {
  currency
  organisationContact
}

fragment GlobalPaymentsForm_configuration on Configuration {
  globalPaymentsHppUrl
}

fragment MonerisProvider_configuration on Configuration {
  currency
  organisationContact
  monerisHostedTokenization {
    uri
    profileId
  }
}

fragment PayPalForm_configuration on Configuration {
  licensingDonationPaymentDescription
  organisationContact
}

fragment PayPalForm_paymentForm on LicensingPaymentForm {
  rows {
    animalName
    licenceType
    amount
  }
}

fragment PayPalPayflowProvider_configuration on Configuration {
  currency
  organisationContact
}

fragment PaymentForm_configuration on Configuration {
  currency
  organisationContact
}

fragment PaymentRowLicenceDetails_configuration on Configuration {
  organisationContact
}

fragment PaymentRowLicenceDetails_paymentRow on LicensingPaymentFormRow {
  rabiesIsValid
  blocked
  animalId
  licenceType
  isRenewal
  isLateFee
}

fragment PaymentRow_configuration on Configuration {
  organisationContact
  ...PaymentRowLicenceDetails_configuration
}

fragment PaymentRow_paymentRow on LicensingPaymentFormRow {
  amount
  currency
  animalId
  animalName
  blocked
  licenceType
  licenceTypeId
  rabiesIsValid
  isRenewal
  isLateFee
  ...PaymentRowLicenceDetails_paymentRow
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "animalIds"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "animalIds",
            "variableName": "animalIds"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "animalId",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "blocked",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rabiesIsValid",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "licensingPaymentMethods",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stripePublishableKey",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "makeADonationEnabled",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "licensingPayPalClientId",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organisationContact",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "concreteType": "LicensingContract",
        "kind": "LinkedField",
        "name": "licensingContract",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contractId",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "PaymentQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "LicensingPaymentForm",
                    "kind": "LinkedField",
                    "name": "licensingPaymentForm",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "LicensingPaymentFormRow",
                            "kind": "LinkedField",
                            "name": "rows",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "PaymentRow_paymentRow"
                                }
                            ],
                            "storageKey": null
                        },
                        (v5 /*: any*/),
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "Donation_paymentForm"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PayPalForm_paymentForm"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Configuration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        (v6 /*: any*/),
                        (v7 /*: any*/),
                        (v8 /*: any*/),
                        (v9 /*: any*/),
                        (v10 /*: any*/),
                        (v11 /*: any*/),
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PaymentRow_configuration"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "Donation_configuration"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "CardConnectForm_configuration"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ConvergeProvider_configuration"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PaymentForm_configuration"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PayPalForm_configuration"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "GlobalPaymentsButton_configuration"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "GlobalPaymentsForm_configuration"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PayPalPayflowProvider_configuration"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "MonerisProvider_configuration"
                        }
                    ],
                    "storageKey": null
                },
                (v12 /*: any*/)
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "PaymentQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "LicensingPaymentForm",
                    "kind": "LinkedField",
                    "name": "licensingPaymentForm",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "LicensingPaymentFormRow",
                            "kind": "LinkedField",
                            "name": "rows",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "amount",
                                    "storageKey": null
                                },
                                (v10 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "animalName",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "licenceType",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "licenceTypeId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isRenewal",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isLateFee",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Configuration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        (v6 /*: any*/),
                        (v7 /*: any*/),
                        (v8 /*: any*/),
                        (v9 /*: any*/),
                        (v10 /*: any*/),
                        (v11 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "donationAmountSuggestions",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "donationRoundUp",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cardConnectSourceUri",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "elavonConvergeLibraryUri",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "licensingDonationPaymentDescription",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "globalPaymentsHppUrl",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "MonerisHostedTokenization",
                            "kind": "LinkedField",
                            "name": "monerisHostedTokenization",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "uri",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "profileId",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                (v12 /*: any*/)
            ]
        },
        "params": {
            "cacheID": "e54c54d95746b2ae0c15606a8923bd09",
            "id": null,
            "metadata": {},
            "name": "PaymentQuery",
            "operationKind": "query",
            "text": "query PaymentQuery(\n  $animalIds: [ID!]!\n) {\n  licensingPaymentForm(animalIds: $animalIds) {\n    rows {\n      animalId\n      blocked\n      rabiesIsValid\n      ...PaymentRow_paymentRow\n    }\n    total\n    ...Donation_paymentForm\n    ...PayPalForm_paymentForm\n  }\n  configuration {\n    licensingPaymentMethods\n    stripePublishableKey\n    makeADonationEnabled\n    licensingPayPalClientId\n    currency\n    organisationContact\n    ...PaymentRow_configuration\n    ...Donation_configuration\n    ...CardConnectForm_configuration\n    ...ConvergeProvider_configuration\n    ...PaymentForm_configuration\n    ...PayPalForm_configuration\n    ...GlobalPaymentsButton_configuration\n    ...GlobalPaymentsForm_configuration\n    ...PayPalPayflowProvider_configuration\n    ...MonerisProvider_configuration\n  }\n  licensingContract {\n    text\n    contractId\n  }\n}\n\nfragment CardConnectForm_configuration on Configuration {\n  cardConnectSourceUri\n}\n\nfragment ConvergeProvider_configuration on Configuration {\n  elavonConvergeLibraryUri\n  currency\n  organisationContact\n}\n\nfragment Donation_configuration on Configuration {\n  currency\n  donationAmountSuggestions\n  donationRoundUp\n}\n\nfragment Donation_paymentForm on LicensingPaymentForm {\n  total\n}\n\nfragment GlobalPaymentsButton_configuration on Configuration {\n  currency\n  organisationContact\n}\n\nfragment GlobalPaymentsForm_configuration on Configuration {\n  globalPaymentsHppUrl\n}\n\nfragment MonerisProvider_configuration on Configuration {\n  currency\n  organisationContact\n  monerisHostedTokenization {\n    uri\n    profileId\n  }\n}\n\nfragment PayPalForm_configuration on Configuration {\n  licensingDonationPaymentDescription\n  organisationContact\n}\n\nfragment PayPalForm_paymentForm on LicensingPaymentForm {\n  rows {\n    animalName\n    licenceType\n    amount\n  }\n}\n\nfragment PayPalPayflowProvider_configuration on Configuration {\n  currency\n  organisationContact\n}\n\nfragment PaymentForm_configuration on Configuration {\n  currency\n  organisationContact\n}\n\nfragment PaymentRowLicenceDetails_configuration on Configuration {\n  organisationContact\n}\n\nfragment PaymentRowLicenceDetails_paymentRow on LicensingPaymentFormRow {\n  rabiesIsValid\n  blocked\n  animalId\n  licenceType\n  isRenewal\n  isLateFee\n}\n\nfragment PaymentRow_configuration on Configuration {\n  organisationContact\n  ...PaymentRowLicenceDetails_configuration\n}\n\nfragment PaymentRow_paymentRow on LicensingPaymentFormRow {\n  amount\n  currency\n  animalId\n  animalName\n  blocked\n  licenceType\n  licenceTypeId\n  rabiesIsValid\n  isRenewal\n  isLateFee\n  ...PaymentRowLicenceDetails_paymentRow\n}\n"
        }
    } as any;
})();
(node as any).hash = '220089fae2a3fbf94e2980fd05229f81';
export default node;
